import { Image as AntImage } from 'antd';
import React, { ReactNode, SyntheticEvent } from 'react'; /*  
 
​AntDesign's "Image" component is being overriden and wrapped in a custom component here. 
 
​When calling "Image" from somewhere in the code, instead of calling antdesign's "Image", you're calling this component. 
 
​For now, it takes the same props as antdesign's Image, and works in the same way.  
​The only difference (for now) is that we changed the default value of the argument "preview" from true to false 
 
​*/

interface ImageProps {
  alt?: string;
  fallback?: string;
  height?: string | number;
  placeholder?: ReactNode;
  preview?: boolean;
  src?: string;
  width?: string | number;
  className?: string;
  onError?: (event: SyntheticEvent<HTMLImageElement, Event>) => void;
}

const Image: React.VFC<ImageProps & React.HTMLAttributes<HTMLDivElement>> = (
  props,
) => {
  return <AntImage {...props} preview={props.preview || false} />;
};

export default Image;
